import React from 'react';
import { SIZES } from '../constants';
import Icon from '../../icon';
const ActionItem = ({ size, iconGlyph }) => (
  <div className="ws-ui-color-selector__action-item">
    <Icon glyph={iconGlyph} size={size === SIZES.large ? 20 : 18} strokeWidth={1.5} type="light" />
  </div>
);

export default ActionItem;
